import script from "./m-meta-data-list.vue?vue&type=script&setup=true&lang=js"
export * from "./m-meta-data-list.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__